import React from 'react';
import { useHistory } from 'react-router-dom';
import { Button } from 'new/elements/support/Button';
import { useHashedState } from 'new/state/hashedState/repository/useHashedState';
import styles from './ViewExpandedPipelineButton.module.scss';
import { SearchFilterTypes } from 'js/constants/visibilityFilters';
import { ROUTE_FLOWS } from 'new/constants/pathnames';

type ViewEntityPipelineButtonProps = {
  title: string;
  flowNodeId: any;
  className?: string;
  variant?: 'outlined' | 'contained';
};

const getFlowURL = (id: number) => `${ROUTE_FLOWS}?search=${SearchFilterTypes.ID}:${id}`;

const ViewEntityPipelineButton = (props: ViewEntityPipelineButtonProps) => {
  const { save } = useHashedState('flows.useExpanded');
  const history = useHistory();

  const handleViewPipelineClicked = () => {
    save(true);
    history.push(getFlowURL(parseInt(props.flowNodeId)));
  };

  const title = props.title || 'Edit Flow';

  return (
    <Button
      variant={props.variant || 'outlined'}
      onClick={handleViewPipelineClicked}
      className={props.className || styles.buttonEditFlow}
    >
      {title}
    </Button>
  );
};

export default ViewEntityPipelineButton;
